import { useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

export const useBreakpoints = () => {
  const theme = useTheme();
  //NOTES:
  //  .down() is exclusive
  //  .up() is inclusive
  //  .only() is inclusive at the breakpoint, exclusive at the next breakpoint

  const isXS = useMediaQuery(theme.breakpoints.only('xs'));
  const isSM = useMediaQuery(theme.breakpoints.only('sm'));
  const isMD = useMediaQuery(theme.breakpoints.only('md'));
  const isLG = useMediaQuery(theme.breakpoints.only('lg'));
  const isXL = useMediaQuery(theme.breakpoints.only('xl'));
  const isXXL = useMediaQuery(theme.breakpoints.up('xxl'));

  return {
    isMobile: useMediaQuery(theme.breakpoints.down('md')),
    isNotMobile: useMediaQuery(theme.breakpoints.up('md')),
    isTablet: useMediaQuery(theme.breakpoints.between('md','lg')),
    isDesktop: useMediaQuery(theme.breakpoints.up('lg')),
    currentBreakpoint: () => {
      if (isXS) return 'xs';
      if (isSM) return 'sm';
      if (isMD) return 'md';
      if (isLG) return 'lg';
      if (isXL) return 'xl';
      if (isXXL) return 'xxl';
      return 'unknown';
    },
  };
};